"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CommonTooltip = function CommonTooltip(props) {
  var toolTipMessage = props.toolTipMessage,
    timeout = props.timeout,
    isOpen = props.isOpen,
    delay = props.delay;
  var _useState = (0, _react.useState)(isOpen),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useState2 = (0, _react.useState)(),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var closeTooltip = function closeTooltip(e) {
    setVisible(false);
  };
  var startAutoCloseTimer = function startAutoCloseTimer() {
    var timerObj = setTimeout(function () {
      closeTooltip();
      setTimer(null);
      clearTimeout(timer);
    }, timeout);
    setTimer(timerObj);
  };
  (0, _react.useEffect)(function () {
    if (visible === true && timeout > 0) {
      startAutoCloseTimer();
    }
  }, [visible]);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setVisible(isOpen);
    }, delay);
  }, [isOpen]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_navigationHeader["default"].tooltipContainer, _navigationHeader["default"].desktop, visible ? _navigationHeader["default"].visible : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _navigationHeader["default"].tooltipCallout
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].tooltipContent
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _navigationHeader["default"].icon
  }), toolTipMessage), /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].tooltipClose,
    onClick: function onClick() {
      return closeTooltip();
    }
  }));
};
CommonTooltip.defaultProps = {
  toolTipMessage: '',
  timeout: 0,
  isOpen: false,
  delay: 0
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CommonTooltip);